import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['frame']

  connect() {
    window.open_modal = this.open
  }

  open = (path) => {
    this.frameTarget.src = path
  }

  close() {
    this.frameTarget.innerHTML = ''
  }

}
